import { render, staticRenderFns } from "./BestTweetItem.vue?vue&type=template&id=0e838d20&"
import script from "./BestTweetItem.vue?vue&type=script&lang=js&"
export * from "./BestTweetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports